import styled from 'styled-components'

export const FieldWrapper = styled.div`
  & > div {
    min-width: 100%;
  }
`
